import React from "react";
import { withRouter } from 'react-router-dom';
import { Icon,Popup, Card, Label, Image, Button } from "semantic-ui-react";
import { dispatch } from '@rematch/core';
import EllipsisTooltip from "../../../../common/EllipsisTooltip";
import LoadingComponent from "../../../../common/LoadingComponent";
import NoTeam from './../../../../../images/grafix-banner/gfx-no-teams.svg'
import { toastr } from 'react-redux-toastr';
let timer = 0;
let delay = 200;
let prevent = false;

class TeamsGridView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      processingDelete: false,
    }
    this.cardClick = this.cardClick.bind(this);

  }
  handleClick(subOrg, key) {
    let thisClick = this;
    timer = setTimeout(async function () {
      if (!prevent) {
        thisClick.cardClick(subOrg, key);
        await dispatch.organizationUnit.setActivePaneIndex(null)
      }
      prevent = false;
    }, delay);
  }
  handleSubClick(subOrg, key) {
    let thisClick = this;
    timer = setTimeout(async function () {
      if (!prevent) {
        thisClick.cardClick(subOrg, key);
        await dispatch.organizationUnit.setActivePaneIndex(1)
      }
      prevent = false;
    }, delay);
  }
  handleUserClick(subOrg, key) {
    let thisClick = this;
    timer = setTimeout(async function () {
      if (!prevent) {
        thisClick.cardClick(subOrg, key);
        await dispatch.organizationUnit.setActivePaneIndex(2)
      }
      prevent = false;
    }, delay);
  }

  async cardClick(subOrg, key) {
    await dispatch.users.storeUnitId(subOrg._id);
    await dispatch.organizationUnit.addSelectedSubOrg(subOrg);
    await dispatch.organizationTab.getUsersTreeAsync({ id: subOrg._id, accountId: this.props.match.params.accountId });
    await dispatch.organizationUnit.getSubOrgResourcePaneAsync(subOrg._id);
    await dispatch.organizationTab.getSelectedSubOrgUsersAsync(subOrg._id);
    await dispatch.initiatives.getInviteBySubOrgAsync(subOrg._id)
    let query = {
      $sort: { createdAt: 1 },
      $skip: 0,
      $limit: this.props.teamsListViewFlag ? 10 : 50
    }
    let payload = {
      query: query,
      organizationId: this.props.selectedOrganisation.id,
      referenceId: subOrg._id
    };
    dispatch.invite.getInvitesAsync(payload);
    await dispatch.organizationUnit.showResourecePane("Home");
    await dispatch.lifeCycle.splitAt("60%")
    await dispatch.lifeCycle.setLibraryCardIndex(key);
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    await dispatch.organizationUnit.showDeleteDisabled(false)
  }

  handleDoubleClick(subOrg, key) {
    clearTimeout(timer);
    prevent = true;
    this.doDoubleClickAction(subOrg, key);
  }

  doDoubleClickAction(subOrg, key) {
    this.cardClick(subOrg, key);
    dispatch.lifeCycle.splitAt("60%");
  }

  async cardSubOrgAdd(subOrg, history, e) {
    e.stopPropagation();
    await dispatch.users.storeUnitId(subOrg._id);
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    await dispatch.organizationUnit.showResourecePane(null);
    await dispatch.organizationUnit.addSelectedSubOrg(subOrg);
    let ops = "Add Sub-Team"
    dispatch.community.addBreadCrumbOps(ops);
    history.push({
      pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/createTeam/addTeamGridView/${subOrg._id}/${subOrg.parentOrganizationId}`,
      state: { parentorgid: subOrg._id }
    });
  }

  async handleClickTeamDetailsPage(subOrg, history, e) {
    e.stopPropagation();
    await dispatch.users.storeUnitId(subOrg._id);
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    await dispatch.organizationUnit.setActivePaneIndex(null)
    await dispatch.organizationUnit.showResourecePane(null);
    await dispatch.organizationUnit.addSelectedSubOrg(subOrg);
    let ops = "Add Sub-Team"
    dispatch.community.addBreadCrumbOps(ops);
    history.push({
      pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/teamDetail/${subOrg._id}`,
      state: { parentorgid: subOrg._id }
    });
  }

  async cardUnitUsersAdd(subOrg, history, e) {
    e.stopPropagation();
    await dispatch.organizationUnit.showResourecePane(null);
    await dispatch.organizationUnit.setActivePaneIndex(null)
    await dispatch.organizationUnit.addSelectedSubOrg(subOrg);
    await dispatch.community.addMainAreaContext('InviteAndAddUsers');
    await dispatch.community.setAddUserContextData('Teams');
    await dispatch.users.storeUnitId(subOrg._id);
    let ops = "Add/Invite Sub-Team Users"
    dispatch.community.addBreadCrumbOps(ops);
    history.push({
      pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/addUser/addTeam/addUserInTeamCard/${subOrg._id}/${subOrg.parentOrganizationId}`,
      state: { parentorgid: subOrg._id }
    });
  }

  redirectTeamCreate() {
    const history = this.props.history;
    history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/createTeam/addTeamGridView/${this.props.selectedSubOrg ? this.props.selectedSubOrg._id : this.props.selectedOrganisation.id}/${this.props.selectedSubOrg ? this.props.selectedSubOrg.parentOrganizationId : this.props.selectedOrganisation.id}`);
  }

  componentWillMount() {
    this.getStart();
  }

  async getStart() {
    dispatch.community.addMainAreaContext('ORGANIZATION');
    dispatch.users.storeUnitId(this.props.match.params.teamId);
    if (this.props.selectedOrganisation.id === this.props.match.params.teamId) {
      let query = {
        $sort: { createdAt: 1 },
        $skip: 0,
        $limit: this.props.teamsListViewFlag ? 10 : 50
      }
      let payload = {
        query: query,
        organizationId: this.props.selectedOrganisation.id,
        accountId: this.props.match.params.accountId
      };
      await dispatch.organizationUnit.getAssignedSubOrgAsync(payload);
      await dispatch.organizationUnit.getOrgByIdAsync(this.props.match.params.workspaceId);
    }
    else {
      let query = {
        $sort: { createdAt: 1 },
        $skip: 0,
        $limit: this.props.teamsListViewFlag ? 10 : 50
      }
      let payload = {
        query: query,
        teamId: this.props.match.params.teamId
      };
      await dispatch.organizationUnit.getSubOrgByParentIdAsync(payload);
      await dispatch.organizationUnit.getSubOrgByIdAsync(this.props.match.params.teamId);
    }
  }
  async deleteSubOrg(subOrg, index, e) {
    try {
        e.stopPropagation();
        await dispatch.organizationUnit.checkSuborganizationBeforeDelete(subOrg._id);
        // this.setState({ processingDelete: true });
        let message = <div className="confirmMessage">
            <h3>Delete Team</h3>
            <label>{subOrg.name}</label>
            <p>Are you sure that you wish to delete this team?</p>
            <span >This action is not reversible</span>
        </div>
        
        toastr.confirm(message, {
            onOk: async () => {
                this.setState({ processingDelete: true });
                await dispatch.organizationUnit.deleteSubOrganizationMainAsync(subOrg);
                this.setState({ processingDelete: false });
            }
        });
        this.setState({ processingDelete: false });
    }
    catch (err) {
        const toastrConfirmOptions = {
            disableCancel: true
        };
        toastr.confirm(err.message, toastrConfirmOptions, {
            onOk: () => {
            }
        });
        this.setState({ processingDelete: false });
    }
  }
  async componentDidUpdate (prevProps) {
    const { match, selectedOrganisation, selectedAccount, dispatch } = this.props;
    if (match.params.teamId !== prevProps.match.params.teamId || 
        match.params.workspaceId !== prevProps.match.params.workspaceId ) {
        let query = {
          $sort: { createdAt: 1 },
          $skip: 0,
          $limit: this.props.teamsListViewFlag ? 10 : 50
        }
        await dispatch.community.addMainAreaContext('ORGANIZATION');
        dispatch.organizationTab.getUsersTreeAsync({ id: match.params.teamId, accountId: match.params.accountId });
        dispatch.users.storeUnitId(match.params.teamId);
        let invitePayload = {
          query: query,
          organizationId: selectedOrganisation.id,
          referenceId: match.params.teamId
        };
        dispatch.invite.getInvitesAsync(invitePayload);
      if (match.params.teamId === match.params.workspaceId) {
        let payload = {
          organizationId: selectedOrganisation.id,
          accountId: selectedAccount._id
        };
        dispatch.organizationUnit.getAssignedSubOrgAsync(payload);
        dispatch.organizationUnit.getOrgByIdAsync(match.params.workspaceId);
      } else {
        let payload = {
          teamId: match.params.teamId
        };
        dispatch.organizationUnit.getSubOrgByParentIdAsync(payload);
        dispatch.organizationUnit.getSubOrgByIdAsync(match.params.teamId);
      }
    }
  }

  render() {
    let checktTeam = !this.props.match.params.teamId || (this.props.match.params.teamId === this.props.selectedOrganisation.id)
    return (
      <div>
        <LoadingComponent active={this.props.deleteSubOrgloading} message="loading..." />
        <div className="orgButtonList" >
          <Card.Group>
            {this.props.subOrgs && this.props.subOrgs.data && this.props.subOrgs.data.length > 0 ?
              this.props.subOrgs.data.map((subOrg, index) => {
                return (
                  <Card className={(subOrg._id === this.props.orgUniqueId && this.props.orgUniqueId !== this.props.match.params.workspaceId) ? "OrgCard activeCard" : "OrgCard "}
                    raised key={index}
                  >
                    <div className="contentHeader">
                      <Card.Header
                        className="pad_5"
                        onClick={() => { this.handleClick(subOrg, index) }}
                        onDoubleClick={() => this.handleDoubleClick(subOrg, index)} 
                        style={{ display: "flex", justifyContent: "space-between" }}
                        >  
                        <EllipsisTooltip name={subOrg.name}
                          line={2}
                          position="top left" 
                          wide="very"
                          style={{ minHeight: "16px" }}
                        />
                        <div style={{ display: "flex", alignItems: "center" }}>
                        <Popup className="popupStyled" inverted trigger={<button class="dashboard"
                           style={{ backgroundColor: 'transparent', paddingLeft: '2px',color: '#FF8F00', cursor: 'pointer',border:'none',outline:'none',boxShadow:'none' }}
                           onClick={(e) => this.deleteSubOrg(subOrg, index, e)} 
                          ><Icon name='trash'></Icon></button>}
                            content='Delete'
                        />
                        <Popup className="popupStyled" inverted trigger={
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="16px"
                              viewBox="0 0 24 24"
                              fill="#B9CAD3"
                              class="dashboard"
                              onClick={(e) => { this.handleClickTeamDetailsPage(subOrg, this.props.history, e) }}
                            >
                              <path d="M0 0h24v24H0z" fill="none" />
                              <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
                            </svg>
                            }
                            content='Dashboard'
                        />
                        </div>
                      </Card.Header>
                    </div>
                    <Card.Content extra>
                      <Icon name="sitemap" />
                      <Label circular color="blue" key="color" className="cardLabel" style={{margin:"0 6px 0 0px"}}>
                        {subOrg.subOrganizations.length}
                      </Label>
                      Sub-Team
                      <div style={{ float: "right", margin: "0" }} onClick={(e) => this.cardSubOrgAdd(subOrg, this.props.history, e)}>
                        <Icon className="plusBtn" name="plus" />
                      </div>
                    </Card.Content>
                    <Card.Content extra>
                      <Icon name="group" />
                      <Label circular color="blue" key="color" style={{margin:"0 6px 0 0px"}}>
                        {subOrg.userCounts}
                      </Label>
                      Users
                      <div style={{ float: "right", margin: "0" }} onClick={(e) => this.cardUnitUsersAdd(subOrg, this.props.history, e)}>
                        <Icon className="plusBtn" name="plus" />
                      </div>
                    </Card.Content>
                  </Card>
                );
              }, this)
              : ''
            }

            {this.props.subOrgs && this.props.subOrgs.data && this.props.subOrgs.data.length === 0 ?

              <div className="w_50 text-center mar_0_auto pad_20">
                <Image src={NoTeam} /> <br />
                <strong as="h3" > {
                  checktTeam ? "No teams to display" : "No sub teams to display"
                }

                </strong><br /><br />
                <strong > Communities are all about communicating, <br /> Collaborating and Managing. Start creating your <br />own teams.</strong><br /><br />
                <Button className="button-submit" onClick={(e) => this.redirectTeamCreate(e)} disabled={this.props.selectedOrganisation.role === 'Manager' && this.props.orgUniqueId === this.props.selectedOrganisation.id}>
                  {checktTeam ? "Create Team" : "Create Sub Team"}
                </Button>
              </div>
              : ""}

          </Card.Group>


        </div>
      </div>
    );
  }
}
export default withRouter(TeamsGridView)
